<template>
	<div :class="$style.Mycenter">
		<div :class="$style.Myheader">
			<img src="../assets/payment_ATM.png" alt="" style="width: 3.125rem;height: 3.125rem;">
		</div>
		<p style="margin: 1.25rem 0;">{{ $t('amtH') }}</p>
		<p :class="$style.pmar">{{ $t('amtT') }}</p>
		<p :class="$style.pmar" style="color: #F2994A;text-decoration: underline;">{{ $t('amt1') }}</p>
		<p :class="$style.pmar">{{ $t('amt2') }}</p>
		<p :class="$style.pmar" style="color: #F2994A;text-decoration: underline;">{{ $t('amt3') }}</p>
		<p :class="$style.pmar">{{ $t('amt4') }}</p>
		<p :class="$style.pmar" style="color: #F2994A;text-decoration: underline;">{{ $t('amt5') }}</p>
		<p :class="$style.pmar">{{ $t('amt6') }}</p>
		
	</div>
</template>
	
<script>
export default {
    name: 'amt',
    props: {
        
    },
    data() {
        return {
            
        }
    },
    watch: {
        
    }
}	
</script>

<style module>
.Mycenter {
	width: 40.625rem;
	height: 21.25rem;
	background-color: #FDF6EC;
	text-align: center;
	margin: 1.25rem auto;
	padding-top: 0.625rem;
}
.Myheader {
	margin: 0.625rem 0;
}
.pmar{
	margin: 0.3125rem 0;
}
@media screen and (max-width: 770px) {
	.Mycenter {
		width: 20.625rem;
		height: 21.25rem;
		background-color: #FDF6EC;
		text-align: center;
		margin: 1.25rem auto;
		padding-top: 0.625rem;
	}
}
</style>
